import * as types from './actionTypes';
import screenService from '../services/screenService';
import Consts from '../Consts';

export function getScreenSuccess(screen) {
  return { type: types.ACTION_GET_SCREEN_SUCCESS, screen};
}

export function continueClicked(screenName){
      let screenData = {
          Values: {ContinueButtonClicked: true}
      };

      return getScreen(screenData, screenName);
  }

  export function resetClicked(screenName){
      let screenData = {
          Values: {ResetButtonClicked: true}
      };

      return getScreen(screenData, screenName);
  }

export function cancel(screenName){
  let screenData = {
    Values: 
      {UserCancelled: true}
  };

  return getScreen(screenData, screenName);
}

export function getScreen(currentScreenData, currentScreenName){
  if(currentScreenData){
    currentScreenData.name = currentScreenName;
  }
  return function(dispatch){
    screenService.getScreendata(currentScreenData)
      .then(function(response){    
        if(response.status == 200)
        {
          response.json().then(function(screenResponse)
          {
            dispatch(getScreenSuccess(screenResponse));
          });
        }
        else
        {
           dispatch(getScreenSuccess(Consts.defaultErrorScreenData));
        }
      })
      .catch(function(error){
        dispatch(getScreenSuccess(Consts.defaultErrorScreenData));
        console.log(error);
      });
  };
}


/** WEBPACK FOOTER **
 ** ./src/actions/screenAction.js
 **/